import myaxios from "./axios.js";
import axios from "axios";
import { getToken } from "@/utils/auth";
import { Message } from "element-ui";
import { Notice } from "view-design";
import store from "@/store";
const request = (method, url, params, isJSON = true) => {
  return new Promise((resolve, reject) => {
    const requestObj = { url, method };
    const key = isJSON ? "data" : "params";
    requestObj[key] = params;
    myaxios(requestObj)
      .then(res => {
        resolve({
          msg: res.data.msg,
          data: res.data.data,
          code: res.data.code
        });
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const post = (url, params, isJSON = true) => {
  return request("post", url, params, isJSON);
};

export const get = (url, params) => {
  return request("get", url, params, false);
};
// 下载后端返回的文件流
export const downloadFile = (url, params, type, fileName, isJSON) => {
  let newaxios = axios.create();
  let config = {
    method: "post",
    url,
    responseType: "blob",
    timeout: 300000, // 5分钟
    headers: {
      token: getToken()
    }
  };
  if (isJSON === false) {
    // 不为application/json
    config.params = params;
  } else {
    config.data = params;
  }
  return newaxios(config).then(res => {
    if (res.status !== 200) {
      Message({
        type: "error",
        message: "导出失败，请稍后重试",
        duration: 3000
      });
      return;
    }
    if ("msSaveOrOpenBlob" in navigator) {
      // 兼容ie
      window.navigator.msSaveOrOpenBlob(res.data, fileName);
      return;
    }
    let blob = new Blob([res.data], { type });
    let url = window.URL.createObjectURL(blob); // 创建下载链接
    let a = document.createElement("a");
    a.download = fileName;
    a.href = url;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url); // 释放掉blob对象
  });
};

//请求文件流
export const requestFileFlow = (
  url,
  method,
  params,
  type,
  fileName,
  isJSON = false
) => {
  let newaxios = axios.create();
  let config = {
    method: method,
    url,
    responseType: "blob",
    timeout: 300000, // 5分钟
    headers: {
      token: getToken()
    }
  };
  if (isJSON === false) {
    // 不为application/json
    config.params = params;
  } else {
    config.data = params;
  }
  return newaxios(config).then(res => {
    if (res.status !== 200) {
      Message({
        type: "error",
        message: "请求失败，请稍后重试",
        duration: 3000
      });
      return;
    }
    if ("msSaveOrOpenBlob" in navigator) {
      // 兼容ie
      window.navigator.msSaveOrOpenBlob(res.data, fileName);
      return;
    }

    let blob = new Blob([res.data], { type });
    let url = window.URL.createObjectURL(blob); // 创建下载链接
    return url;
  });
};
export const getObjType = obj => {
  var toString = Object.prototype.toString;
  var map = {
    "[object Boolean]": "boolean",
    "[object Number]": "number",
    "[object String]": "string",
    "[object Function]": "function",
    "[object Array]": "array",
    "[object Date]": "date",
    "[object RegExp]": "regExp",
    "[object Undefined]": "undefined",
    "[object Null]": "null",
    "[object Object]": "object"
  };
  if (obj instanceof Element) {
    return "element";
  }
  return map[toString.call(obj)];
};
// 对象深拷贝
export const deepClone = data => {
  let type = getObjType(data);
  let obj;
  if (type === "array") {
    obj = [];
  } else if (type === "object") {
    obj = {};
  } else {
    // 不再具有下一层次
    return data;
  }
  if (type === "array") {
    for (let i = 0, len = data.length; i < len; i++) {
      obj.push(deepClone(data[i]));
    }
  } else if (type === "object") {
    for (let key in data) {
      obj[key] = deepClone(data[key]);
    }
  }
  return obj;
};
// 播放语音
let isPlayOver = false;
export const playAudio = (audioUrl, playAudioFlag, handleSwitch = false) => {
  if (handleSwitch) {
    return;
  }
  const audioEle = document.getElementById("audio");
  //语音开关是开启状态
  if (playAudioFlag === "1") {
    //有音频元素
    if (audioEle) {
      if (isPlayOver) {
        setTimeout(() => {
          audioEle.src = audioUrl[0];
          audioEle.play(); //播放
          isPlayOver = false;
          // audioEle.src = audioUrl;
          // audioEle.play(); //播放
        }, 3000);
      }
      return;
    }
    let audio = document.createElement("audio");
    audio.id = "audio";
    audio.style.display = "none";
    document.body.appendChild(audio);
    //监听当前音频是否播放完
    audio.addEventListener(
      "ended",
      () => {
        isPlayOver = true;
        store.commit("common/DEL_CUR_AUDIO_URL");
      },
      false
    );
    if (audioUrl.length) {
      setTimeout(() => {
        // audio.src = audioUrl;
        // audio.play(); //播放
        audio.src = audioUrl[0];
        audio.play(); //播放
      }, 3000);
    }
    return;
  }
  //语音开关是关闭状态
  //有音频元素
  if (audioEle) {
    setTimeout(() => {
      // audioEle.src = audioUrl;
      // audioEle.pause(); //暂停
      audioEle.src = audioUrl[0];
      audioEle.pause(); //暂停
      //删除所有音频路径
      store.commit("common/DEL_ALL_AUDIO_URL");
    }, 3000);
    return;
  }
  let audio = document.createElement("audio");
  audio.id = "audio";
  audio.style.display = "none";
  document.body.appendChild(audio);
  if (audioUrl.length) {
    setTimeout(() => {
      audio.src = audioUrl[0];
      audio.pause(); //暂停
    }, 3000);
  }
};

let isConnecting = false;
export const initWebSocket = (token, user) => {
  if (process.env.NODE_ENV === 'development') return
  connection(token, user);
  // 断开重连机制,尝试发送消息,捕获异常发生时重连
  window.socketTimer = setInterval(() => {
    if (!isConnecting) {
      console.log("socket已关闭或发生错误");
      connection(token, user);
    }
  }, 60000);
};

//socket连接
export const connection = (token, user) => {
  if (location.origin === "http://127.0.0.1:8081") {
    window.socket = new WebSocket(
      `ws://127.0.0.1:8080/websocket/${token}@${user.id}`
    ); //本地
  } else if (location.origin === "http://localhost:8080") {
    window.socket = new WebSocket(
      `ws://218.244.154.125:8077/websocket/${token}@${user.id}`
    ); //rdx开发本地
  } else {
    const url = location.origin
      .replace("http", "ws")
      .replace("https", "wss")
      .replace("8077", "8094"); //线上
    window.socket = new WebSocket(`${url}/websocket/${token}@${user.id}`);
  }
  //打开事件
  window.socket.onopen = function() {
    console.log("Socket 已打开");
    isConnecting = true;
    //window.socket.send("这是来自客户端的消息" + location.href + new Date());
  };
  //获得消息事件
  window.socket.onmessage = msg => {
    const data = JSON.parse(msg.data); // msg.body存放的是服务端发送给我们的信息
    // 有语音播报
    if (data.type === 2) {
      const { type, videoPath, factoryName, areaName } = JSON.parse(
        data.result
      ); // msg.body存放的是服务端发送给我们的信息
      let audioUrl = "";
      if (location.origin === "http://localhost:8080") {
        audioUrl = `https://jiarong.0101data.cn/files/mp3/${videoPath}`;
      } else {
        audioUrl = `${location.origin}/files/mp3/${videoPath}`;
      }
      let title = "VMS视频监测系统告警";
      Notice.warning({
        title: title,
        desc: `告警类型：${type}<br />
        告警厂区：${factoryName}<br />
        告警区域：${areaName}`,
        duration: 3
      });
      store.commit("common/SET_AUDIO_URL", audioUrl);
    }

    //告警数据
    if (data.type === 3) {
      const alarmData = JSON.parse(data.result); // msg.body存放的是服务端发送给我们的信息
      store.commit("common/SET_ALARM_DATA", alarmData);
    }
  };
  //关闭事件
  window.socket.onclose = () => {
    isConnecting = false;
  };
  //发生了错误事件
  window.socket.onerror = () => {
    isConnecting = false;
    //此时可以尝试刷新页面
  };
};

/**
 * 判空
 * @param {any} value
 * @return {boolean}
 */
export function isEmpty(value) {
  return value == null || value === ''
}

/**
 * 将source合并到target中
 * 仅对target中存在的键进行合并
 * 仅当遇到对象值时进行递归
 *
 * @param target {Object}
 * @param source {Object}
 */
export function mergeObj(target, source) {
  if (isEmpty(target) || isEmpty(source)) return

  for (const key of Object.keys(target)) {
    if (!(key in source)) continue

    // 数组类型直接赋值，不做深拷贝
    if (Array.isArray(target[key])) {
      target[key] = Array.isArray(source[key]) ? [...source[key]] : []
      continue
    }

    // number类型不考虑NaN
    if (typeof target[key] === 'number') {
      target[key] = source[key] || 0
      continue
    }

    // 非空对象递归处理
    if (target[key] !== null && typeof target[key] === 'object') {
      mergeObj(target[key], source[key])
      continue
    }

    target[key] = source[key]
  }
}

/**
 * 对数组按指定字段进行顺序分组，返回Map
 * @template T
 * @param {T[]} array 需要分组的数组
 * @param {any|function(item: T): any} [uniqueKey] 数组元素可作为唯一标识的字段名，为空时使用元素本身
 * @return {Map<any, array<T>>}
 */
export function groupBy(array, uniqueKey) {
  const keyGetter = !uniqueKey
    ? i => i
    : typeof uniqueKey === 'function'
      ? uniqueKey
      : i => i[uniqueKey]

  return array.reduce((map, item) => {
    const key = keyGetter(item)
    if (!map.has(key)) {
      return map.set(key, [item])
    }
    map.get(key).push(item)
    return map
  }, new Map())
}

/**
 * 返回去重后的新数组，原始顺序不会发生变化
 * @template T
 * @param {T[]} array 需要去重的数组
 * @param {any|function(item: T): any} [uniqueKey] 数组元素可作为唯一标识的字段名，为空时使用set进行去重
 * @return {T[]}
 */
export function deduplicate(array, uniqueKey) {
  if (uniqueKey == null) {
    return Array.from(new Set(array))
  }

  const deduplicated = []

  groupBy(array, uniqueKey).forEach((value) => {
    deduplicated.push(value[0])
  })

  return deduplicated
}

/**
 * 浅拷贝指定对象，忽略指定属性，暂不支持排除嵌套字段
 * @param {Object} source
 * @param {string|string[]|function} excludes 需要排除的字段名
 * @return {Object}
 */
export function omit(source, ...excludes) {
  if (isEmpty(source) || !excludes.length) return source

  const predicate =
    typeof excludes[0] === 'function'
      ? excludes[0]
      : Array.isArray(excludes[0])
        ? key => !excludes[0].includes(key)
        : key => !excludes.includes(key)

  return Object
    .entries(source)
    .reduce((obj, [key, value]) => {
      predicate(key) && (obj[key] = value)
      return obj
    }, Object.create(null))
}



// WEBPACK FOOTER //
// ./src/utils/index.js